export default function () {
  return {
    banlistpgs: [],
    banlistpgsCurrentPage: 1,
    banlistpgsLastPage: 1,
    banlistpgsPerPage: 0,
    banlistpgsTotal: 0,
    banlistpgsLoading: false,
    indexPage: null,
    search: ''
  }
}
